import { Box, ListEntry, OSKThemeType, Select, Spinner, Typography } from 'oskcomponents';
import { StacAPI } from 'oskcore';
import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

export type ProductPickerProps = {
    /** The default value to select */
    defaultValue: string;
    /** Method to invoke when a selection happens */
    onChange: (product: string) => void;
};

export const ProductPicker = ({ defaultValue, onChange }: ProductPickerProps) => {
    const theme = useTheme() as OSKThemeType;
    const [productLevelOptions, setProductLevelOptions] = useState<ListEntry[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<string>('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        setIsLoading(true);
        StacAPI.getCollections()
            .then((collections) => {
                const options = collections.map((collection) => ({
                    label: (
                        <div>
                            <b>{collection.title}</b> -
                            <Typography
                                variant="body4"
                                as="span"
                                color={theme.colors.gray80}
                                style={{ paddingLeft: '4px' }}
                            >
                                {collection.description}
                            </Typography>
                        </div>
                    ),
                    value: collection.id,
                }));

                setProductLevelOptions(options);

                if (!defaultValue && options.length > 0) {
                    setSelectedProduct(options[0].value);
                }

                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                setError(err.toString());
            });
    }, []);

    useEffect(() => {
        setSelectedProduct(defaultValue);
    }, [defaultValue]);

    if (isLoading) {
        return (
            <Box center="horizontal">
                <Spinner size="Tiny" variant="Box" />
            </Box>
        );
    }

    if (error) {
        return (
            <Box center="horizontal">
                <Typography variant="body3" color="red" strong>
                    {error}
                </Typography>
            </Box>
        );
    }

    return (
        <Select
            name="product_level"
            variant="primary"
            inverted={true}
            maxHeight={'250px'}
            items={productLevelOptions}
            defaultValue={selectedProduct}
            onSelect={(option) => {
                if (option) {
                    setSelectedProduct(option.value);
                    onChange && onChange(option.value);
                }
            }}
        />
    );
};

export default ProductPicker;
